import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { VendorSelect } from './VendorSelect/VendorSelect'

export const vendorContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.vendor.vendorSelect).to(VendorSelect)
})
